'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.t = exports.decodeEntities = exports.replaceVars = exports.getLocale = undefined;

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var _JSON$parse = JSON.parse((0, _functional.getElement)('#StoreI18n').innerHTML),
    locale = _JSON$parse.locale,
    messages = _JSON$parse.messages;

var entityMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': "'",
  '&#x60;': '`',
  '&#39;': "'"

  /**
   * Retrieves the Shop locale
   *
   * @returns {string} - The Shop locale
   */
};var getLocale = exports.getLocale = function getLocale() {
  return locale;
};

/**
 * Replaces Liquid placeholder variables from a translated message
 *
 * @param {string} message - A message that contains variables to be replaced
 * @param {Object} [replacement={}] - An object where the key is the variable to replace and the value is what it's going to be replaced with
 *
 * @returns {string} - The translation message
 */
var replaceVars = exports.replaceVars = function replaceVars(message) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(replacement)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = (0, _slicedToArray3.default)(_ref, 2);

      var key = _ref2[0];
      var value = _ref2[1];

      message = message.replace('{{ ' + key + ' }}', value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return message;
};

/**
 * Decodes HTML entities from translation messages
 *
 * @param {string} message - The translation message
 *
 * @returns {string} - The translation message, with the decoded entities
 */
var decodeEntities = exports.decodeEntities = function decodeEntities(message) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(entityMap)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref3 = _step2.value;

      var _ref4 = (0, _slicedToArray3.default)(_ref3, 2);

      var key = _ref4[0];
      var value = _ref4[1];

      message = message.replace(key, value);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return message;
};

/**
 * Retrieves the translation message from a key. Translation messages must be placed in 'script.i18n.liquid
 *
 * @param {string} key - The key of the translation message
 * @param {Object} [replacement={}] - The liquid variable name and the replacement string
 *
 * @returns {string} - The translation message
 */
var t = exports.t = function t(key) {
  var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var message = messages[key];

  if (!message) return 'Missing message: ' + key;

  message = replaceVars(message, replacement);
  message = decodeEntities(message);

  return message;
};